import React from "react"
import fetchApi, { getToken } from '../../../../utils/fetchApi'
import { Button } from "@material-ui/core"
import { AppProp, connectApp } from '../../../../reducers'
import { isAdmin, isReferent } from '../../../../reducers/auth/session'
import DatePickerButton, { DateIntervalButtonProps } from "../../Utils/DatePickerButton"
import useStyles from "../../Utils/ExportReportsCard/styles"
import { useDispatch } from "react-redux"
import { pushAlert } from "../../../../actions/alert"
import { fetchJobs } from "../../../../actions/job/jobList"

export interface ExportDescriptionProps {
  url: string
  description?: string
}

type ExportButtonProps = DateIntervalButtonProps & AppProp<'session'> & ExportDescriptionProps

const ExportClassesButton = ({ dateInterval, session, description, url }: ExportButtonProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const prefix = isAdmin(session) ? '' : isReferent(session) ? 'references/' : 'remote-teachers/'

  const getClasses = async () => {
    const handleResponse = (dispatch: any, response: any) => {
      if (response.error) {
        dispatch(pushAlert(response.error, true))
      }
      if (response.message) {
        dispatch(pushAlert(response.message))
        dispatch(fetchJobs());
      }
    }

    const response = await fetchApi(getToken(), 'GET', `${prefix}${url}?from=${dateInterval.from.format()}&to=${dateInterval.to.format()}`)

    handleResponse(dispatch, response)

  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 12 }}>
     {description && <span>{description}</span>}
      <Button variant='contained' className={classes.download}
        onClick={() => dateInterval.from && dateInterval.from.isValid() && dateInterval.to && dateInterval.to.isValid() ? getClasses() :
          dispatch(pushAlert('Verifique las Fechas', true))}>
        Solicitar csv
      </Button>
    </div>

  )
}

const ConnectedExportButton = connectApp('session')(ExportClassesButton)

export const DownloadClasses = () => {
  const WrappedExportButton = (props: DateIntervalButtonProps) => (
    <ConnectedExportButton {...props} url='classes/export' description='Exportar un reporte de las clases dictadas en el período'/>
  )
  return <DatePickerButton style={{ maxWidth: '170px' }} title='Reporte de clases dictadas' Button={WrappedExportButton} />
}
export const DownloadCoordinations = () => {
  const WrappedExportButton = (props: DateIntervalButtonProps) => (
    <ConnectedExportButton {...props} url='classes/coordinationExport' description='Exportar un reporte de la coordinación por clase entre DR y DA' />
  )
  return <DatePickerButton  style={{ maxWidth: '170px' }} title='Coordinación Docente Remoto y Docente de Aula' Button={WrappedExportButton} />
}

